import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ROLES } from './app-const';
import { AuthGuard } from './core/guards/auth.guard';
import { Page404Component } from './extrapages/page404/page404.component';
import { LoaderPageComponent } from './layouts/loader-page/loader-page.component';


const routes: Routes = [
  {
    path: '',
    redirectTo: 'account/choose',
    pathMatch: 'full'
  },
  {
    path: 'pmo',
    loadChildren: () => import('./pmo-pages/pmo.module').then(m => m.PMOModule),
    canActivate: [AuthGuard],
    data: {
      roles: [ROLES.CAN_USE_PROJECT_MANAGER]
    }
  },
  { path: 'account', loadChildren: () => import('./account/account.module').then(m => m.AccountModule) },
  {
    path: 'task-manager',
    loadChildren: () => import('./task-manager-pages/task-manager-pages.module').then(c => c.TaskManagerPagesModule),
    canActivate: [AuthGuard],
    data: {
      roles: [ROLES.CAN_USE_TASK_MANAGER]
    }
  },
  {
    path: 'plant-nursery',
    loadChildren: () => import('./plant-nursery-pages/plant-nursery-pages.module').then(c => c.PlantNurseryPagesModule),
    canActivate: [AuthGuard],
    data: {
      roles: [ROLES.CAN_USE_NURSERY_MANAGER]
    }
  },
  {
    path: 'system-setting',
    loadChildren: () => import('./system-setting/system-setting.module').then(c => c.SystemSettingModule),
    canActivate: [AuthGuard],
    data: {
      roles: [ROLES.ADMIN]
    }
  },

  {
    path: '',
    loadChildren: () => import('./extrapages/extrapages.module').then(m => m.ExtrapagesModule),
    canActivate: [AuthGuard]
  },


  {
    path: 'loader',
    component: LoaderPageComponent
  },
  {
    path: '**',
    component: Page404Component
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top', onSameUrlNavigation: 'ignore' })],
  exports: [RouterModule]
})

export class AppRoutingModule { }
